var _mask, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeSection2Icon3 = function SvgHomeSection2Icon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 80,
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "home-section2-icon-3_svg__a",
    height: 5,
    maskUnits: "userSpaceOnUse",
    width: 109,
    x: 20,
    y: 70
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.625 70.072H128.95v4.745H20.625z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M72.987 6.136 36.943 24.77h76.292L77.192 6.137a4.578 4.578 0 0 0-4.205 0z",
    fill: "#6400ff",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#home-section2-icon-3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M127.572 74.817H22.003a1.378 1.378 0 0 1-1.378-1.378v-1.99c0-.76.617-1.377 1.378-1.377h105.569c.761 0 1.378.617 1.378 1.378v1.988c0 .762-.617 1.379-1.378 1.379z",
    fill: "#d7cbe7",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#efe7ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.158 67.408h7.462V29.033h-7.462zM61.904 67.408h7.462V29.033h-7.462zM80.742 67.408h7.462V29.033h-7.462zM99.488 67.408h7.462V29.033h-7.462z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#9049ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.603 33.233h-7.427a1.659 1.659 0 0 1-1.658-1.658v-1.659H52.26v1.659c0 .916-.742 1.659-1.658 1.659zM69.349 33.233h-7.427a1.658 1.658 0 0 1-1.658-1.658v-1.659h10.743v1.659c0 .916-.742 1.659-1.658 1.659zM88.187 33.233H80.76a1.659 1.659 0 0 1-1.658-1.658v-1.659h10.743v1.659c0 .916-.742 1.659-1.658 1.659zM106.933 33.233h-7.427a1.659 1.659 0 0 1-1.658-1.658v-1.659h10.743v1.659c0 .916-.742 1.659-1.658 1.659zM99.542 61.61h7.426c.916 0 1.659.742 1.659 1.658v1.658H97.883v-1.658c0-.916.742-1.659 1.659-1.659zM80.796 61.61h7.426c.916 0 1.659.742 1.659 1.658v1.658H79.136v-1.658c0-.916.743-1.659 1.658-1.659zM61.958 61.61h7.426c.916 0 1.659.742 1.659 1.658v1.658H60.299v-1.658c0-.916.742-1.659 1.659-1.659zM43.21 61.61h7.426c.916 0 1.658.742 1.658 1.658v1.658H41.551v-1.658c0-.916.742-1.659 1.658-1.659z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.577 63.678H36.998a3.844 3.844 0 0 0-3.844 3.844v2.551h83.267v-2.551a3.844 3.844 0 0 0-3.844-3.844zM34.813 31.166a1.659 1.659 0 0 1-1.659-1.659v-5.21c0-.916.743-1.658 1.659-1.658h79.95c.916 0 1.659.742 1.659 1.658v5.21c0 .917-.743 1.66-1.659 1.66z",
    fill: "#efe7ff"
  }))));
};
export default SvgHomeSection2Icon3;